module.exports = __webpack_public_path__ + "img/836.e9722dc2.png";